<template>
    <div>
        <practioner-dashboard></practioner-dashboard>
    </div>
</template>

<script>

    import PractionerDashboard from "./PractionerDashboard";
    export default {
        name: "MedecinDashboard",
        components: {PractionerDashboard},
    }
</script>

<style scoped>

</style>